import { ResponseReult, SyncNg, syncInject } from 'sync-engine';
import { BaseNestjsResponse, ResultPipeHandler } from 'nestjs-model-utility';
import { Observable, map } from 'rxjs';

export class DependentApiUpdate implements ResultPipeHandler {
  @syncInject()
  syncNg!: SyncNg;
  constructor() {}
  handler<Result extends ResponseReult<BaseNestjsResponse>>(
    $result: Observable<Result>,
  ) {
    return $result.pipe(
      map((value) => {
        if (value?.response?.updated) {
          this.syncNg.updateStore(
            value.response.updated.map((apiName) => {
              return { apiName };
            }),
          );
        }
        return value;
      }),
    );
  }
}
